import * as Yup from "yup";

export const chartAccountSchema = Yup.object().shape({
  description: Yup.string().required("Por favor, insira a descrição."),
});
